<template>
  <div class="popup">
    <div class="popup__confirmed" v-if="emailConfirmed">
      <head-title class="head-title">Email successfully confirmed!</head-title>
      <div class="popup__body">
        <div class="popup__message">
          Thank you! Now you can login and use all the functionality which required a confirmed email.
        </div>
        <router-link v-if="loginInfo" to="/settings">
          <button-el red>settings</button-el>
        </router-link>
        <button-el red @click.native="openLoginModal" v-else>login</button-el>
      </div>
    </div>

    <div class="popup__error" v-else-if="emailConfirmedError">
      <head-title class="head-title">Link is outdated!</head-title>
      <div class="popup__body popup__body_error">
        <div class="popup__message">
          Unfortunately, your email confirmation link is outdated. If you still wish to confirm your email, you will need to sign in again
        </div>
        <router-link v-if="loginInfo" to="/settings">
          <button-el red>settings</button-el>
        </router-link>
        <button-el v-else-if="actionBtnSignUp" red @click.native="openRegisterModal">sign up</button-el>
        <button-el v-else-if="actionBtnLogin" red @click.native="openLoginModal">login</button-el>
      </div>
    </div>

    <div class="popup__error" v-else-if="passwordForgotError">
      <head-title class="head-title">Link is outdated!</head-title>
      <div class="popup__body popup__body_error">
        <div class="popup__message">
          This link is outdated, please, try to reset password again
        </div>
        <button-el red @click.native="openForgotModal" class="popup__reset-btn">reset password again</button-el>
      </div>
    </div>

    <div class="popup__changed" v-else-if="passwordChanged">
      <head-title class="head-title">Password successfully changed!</head-title>
      <div class="popup__body">
        <div class="popup__message">
          Thank you! Now you can login and use all the functional which require changed password.
        </div>
        <router-link v-if="loginInfo" to="/all-currencies">
          <button-el red>Ok</button-el>
        </router-link>
        <button-el red @click.native="openLoginModal" v-else>login</button-el>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import ActionBtns from 'src/models/ActionBtns';
  import loginModalTabs from 'src/models/LoginModalTabs';

  export default {
    data: () => ({
      ActionBtns,
    }),
    props: {
      emailConfirmed: Boolean,
      emailConfirmedError: Boolean,
      passwordForgotError: Boolean,
      passwordChanged: Boolean,
    },
    computed: {
      ...mapState('userData', ['loginInfo']),
      actionBtnSignUp() {
        return this.$router.meta.actionBtn === ActionBtns.signup;
      },
      actionBtnLogin() {
        return this.$router.meta.actionBtn === ActionBtns.login;
      },
    },
    methods: {
      ...mapActions('settings', [
        'toggleLoginModal',
      ]),
      openLoginModal() {
        this.toggleLoginModal({ val: true, activeTab: loginModalTabs.login });
      },
      openRegisterModal() {
        this.toggleLoginModal({ val: true, activeTab: loginModalTabs.register });
      },
      openForgotModal() {
        this.toggleLoginModal({ val: true, activeTab: loginModalTabs.forgot });
      },
    },
  };
</script>


<style lang="scss" scoped>
  .popup {
    max-width: 420px;
    background: $white-color2;
    border-radius: 5px;
    margin: auto;
    &__message {
      @include font(13px);
      line-height: 21px;
      margin-bottom: 38px;
    }
    &__body {
      padding: 24px 30px 30px;
      &_error {
        padding: 24px 60px 30px 30px;
      }
    }
    .head-title {
      @include font(24px, $black-color1, medium);
      border-bottom: 1px solid $white-color5;
      padding: 32px 28px;
    }
    &__reset-btn {
      max-width: 200px !important;
    }
    &__changed {
      .head-title {
        font-size: 22px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MessageDisplayer.vue